import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import {
    Button, Form, Input, message
} from 'antd';
import { formItemLayout, tailLayout } from './ModalLayout';
import { useTranslation } from 'react-i18next';
import * as Service from '../core/Service';

const AdminForm = (props) => {
    const {t} = useTranslation();

    const [form] = Form.useForm();
    const [formData, setFormData] = useState({});
    const {
        selectedRecord,
        openModal,
        isShowPassword
    } = props;

    useEffect(() => {
        console.log('reset data')
        form.resetFields();
        console.log('setting data', selectedRecord)
        setFormData(selectedRecord);
    }, [form, selectedRecord]);

    useEffect(() => {
        form.setFieldsValue(formData);
    }, [form, formData]);

    const onFinish = async (formObj) => {
        let method = `POST`;
        let endpoint = `/api/admin`;

        console.log("admin_id", formData.admin_id);
        let bodyObj = _.clone(formObj);
        if (formData.admin_id > 0) {
            bodyObj.admin_id = formData.admin_id;
            method = `PUT`;
        }

        try {
            let resp = await Service.call(method, endpoint, bodyObj);
            if (resp.errorMessage) {
                message.error(resp.errorMessage);
                return;
            }
            message.success(t('common.success'));
            return openModal(false);
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <Form
            {...formItemLayout}
            form={form}
            onFinish={onFinish}
            initialValues={formData}
        >
            {
                !_.isUndefined(formData.username)
                    ? null
                    : (
                        <>
                            <Form.Item
                                name="email"
                                label={t('common.email')}
                                rules={[{ required: true, message: `${t('common.please_input')}` }]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                name="nickname"
                                label={t('admin.nickname')}
                                rules={[{ required: true, message: `${t('common.please_input')}` }]}
                            >
                                <Input />
                            </Form.Item>
                            {isShowPassword ?
                                <>
                                    <Form.Item
                                        name="password"
                                        label={t('common.password')}
                                        rules={[{ required: true, message: `${t('common.please_input')}` }]}
                                    >
                                        <Input.Password />
                                    </Form.Item>
                                    <Form.Item
                                        name="confirm_password"
                                        label={t('admin.confirm_password')}
                                        rules={[
                                            { required: true, message: `${t('common.please_input')}` },
                                            ({ getFieldValue }) => ({
                                                validator(self, value) {
                                                    if (!value || getFieldValue('password') === value) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(new Error(`${t('admin.password_not_match')}`));
                                                },
                                            }),
                                        ]}
                                    >
                                        <Input.Password />
                                    </Form.Item>
                                </>
                                : null
                            }
                        </>
                    )
            }
            <Form.Item
                name="mobile"
                label={t('admin.mobile')}
                rules={[{ required: true, message: `${t('common.please_input')}` }]}
            >
                <Input />
            </Form.Item>
            <Form.Item {...tailLayout}>
                <Button
                    type="primary"
                    htmlType="submit"
                >
                    {t('common.submit')}
        </Button>
            </Form.Item>
        </Form >
    );
}

export default AdminForm;
